import { render, staticRenderFns } from "./product-order-indicator.vue?vue&type=template&id=21e26870&scoped=true&"
import script from "./product-order-indicator.vue?vue&type=script&lang=ts&"
export * from "./product-order-indicator.vue?vue&type=script&lang=ts&"
import style0 from "./product-order-indicator.vue?vue&type=style&index=0&id=21e26870&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e26870",
  null
  
)

export default component.exports